import { useQuery } from "@tanstack/react-query"

import { TraceabilityResponses } from "@tfg/types/endpoints/traceability"
import { getTraceabilityRequestsQueryParams } from "@tfg/types/schemas/traceabilityRequests"

import { httpClient } from "~/backend/axios"
import { useAuth } from "~/store/auth-context"

export const useGetTraceabilityRequestsTypes = ({
  filters,
}: {
  filters: getTraceabilityRequestsQueryParams["filters"]
}) => {
  const { user } = useAuth()

  return useQuery({
    queryKey: ["traceabilityRequestsTypes", filters, user?.id],
    queryFn: async () => {
      const res = await httpClient.get<
        TraceabilityResponses.TraceabilityRequestType[]
      >("/traceability-requests/filters/types", { params: { filters } })
      return res.data
    },
  })
}
